import script from "./Profile.vue?vue&type=script&lang=ts&setup=true"
export * from "./Profile.vue?vue&type=script&lang=ts&setup=true"

import "./Profile.vue?vue&type=style&index=0&id=341d241e&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-341d241e"]])

export default __exports__